<template>
    <div class="widget widget--notifications">
        <div class="notifications-slider">
            <latest-notification v-for="latestNotification in latestNotifications"
                                 :latest-notification="latestNotification"
                                 :key="latestNotification.id"
                                 :view-route="baseRoute + '/' + latestNotification.id"
                                 :mark-as-read-string="markAsReadString"
                                 :read-notifications="readNotifications"></latest-notification>
        </div>
    </div>
</template>

<script>
    import LatestNotification from './latestNotification.vue';
    export default {
        props: ['getRoute', 'baseRoute', 'readNotifications'],
        components: {
            'latest-notification': LatestNotification,
        },
        data() {
            return {
                latestNotifications: [],
                markAsReadString: '',
            }
        },
        created() {
            axios.get(this.getRoute)
                .then((res) => {
                    this.latestNotifications = res.data.latestNotifications;
                    this.markAsReadString = res.data.markAsReadString;

                    if (this.latestNotifications.length > 0) {
                        $('.notifications-slider').addClass('notifications-slider-margin');

                        setTimeout(function () {
                            $('.notifications-slider').slick({
                                dots: true,
                                customPaging : function(slider, i) {
                                    let thumb = $(slider.$slides[i]).data();
                                    return '<a class="dot btn btn-success">' + (i+1) + '</a>';
                                },
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                adaptiveHeight: true,
                                autoplay: true,
                                autoplaySpeed: 5000,
                            });
                        }, 0);
                    }
                });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/latestNotifications.vue